import { render, staticRenderFns } from "./StageTag.vue?vue&type=template&id=5c2272af&scoped=true"
import script from "./StageTag.vue?vue&type=script&lang=js"
export * from "./StageTag.vue?vue&type=script&lang=js"
import style0 from "./StageTag.vue?vue&type=style&index=0&id=5c2272af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2272af",
  null
  
)

export default component.exports